import { overrides } from './environment.development';
import { ENVIRONMENT_DEFAULTS, Environment } from './environment.model';

export const environment: Environment = {
  ...ENVIRONMENT_DEFAULTS,

  icmChannel: 'inSPIRED-inTRONICS_Business-Site',
  //icmBaseURL: 'https://localhost:8443',
  //icmBaseURL: 'https://10.3.1.44:8443',
  //icmBaseURL: 'https://pwa-public-demo.test.intershop.com',
  //icmBaseURL: 'https://pwa-ish-demo.test.intershop.com',
  icmBaseURL: 'https://dssdias-sit.intershop.cloud',
  themeColor: '#12c1db',
  icmApplication: '-',
  hybridApplication: 'smb-responsive',

  features: [
    ...ENVIRONMENT_DEFAULTS.features,
    'businessCustomerRegistration',
    'costCenters',
    'maps',
    'punchout',
    'quickorder',
    'quoting',
    'orderTemplates',
    'guestCheckout',
    'tracking',
    /* ICSA Features */
    'customQuickorder',
    'saveForLater',
    'onePageCheckout',
    'multipleShippingCheckout',
    'salesRep',
    'dotCms',
    'bulkOrder',
    'extraConfiguration',
    'voiceSearch',
  ],
  gtmToken: 'GTM-5L2XV9F',
  productListingItemsPerPage: {
    category: 12,
    search: 12,
    master: 6,
  },
  defaultProductListingViewType: 'grid',
  dotCmsApiToken:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcGk4ZDQyNzMyYS0wNGQwLTRhNmYtYTA2ZC1lNTRjYjgzYzdjNGEiLCJ4bW9kIjoxNjk5NTk4NDU4MDAwLCJuYmYiOjE2OTk1OTg0NTgsImlzcyI6ImI4MDliZmI4NjgiLCJsYWJlbCI6ImludGVyc2hvcCIsImV4cCI6MTc5NDI0OTAwMCwiaWF0IjoxNjk5NTk4NDU4LCJqdGkiOiI2YTBiZTM2NS01N2Y2LTQ4MDgtOWZlNS1jNDRhNjg3ODZmNDMifQ.hErkVYrJPfo28xGF6K9nE-BnT9AReMMpMbOGzVFMrm8',

  /* identityProvider: 'Punchout',
  identityProviders: {
    Punchout: {
      type: 'PUNCHOUT',
    },
  }, */
  ...overrides,
};
